import { months } from '../data/conversation';
import {
  // fetchConversationsListParams,
  SidebarGroup,
  SidebarItem,
} from '../types/sidebar-conversation';
import { differenceInCalendarDays, isToday, isValid, isYesterday, parseISO } from 'date-fns';
// import { clients } from '../../../../lib/https';
// import { useGlobalQuery } from '../../../../state/query-client/hooks';
// import { ChatStoreState, useChatStore } from '../../../../state/store/chat/useChatStore';

export const toPascalCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export function groupConversations(
  conversations: SidebarItem[],
  t: (key: string) => string
): SidebarGroup[] {
  const indexGroupIdMap: Map<string, number> = new Map();
  const result: SidebarGroup[] = [];

  const now = new Date();
  const currentYear = now.getFullYear();

  const sortedConversations = conversations
    .slice()
    .sort((a, b) => parseISO(b.LastUpdatedDate).getTime() - parseISO(a.LastUpdatedDate).getTime());

  for (const conversation of sortedConversations) {
    const createdDate = parseISO(conversation.LastUpdatedDate);
    if (!isValid(createdDate)) {
      console.error(
        `Invalid date for conversation ${conversation.ConversationId}: ${conversation.LastUpdatedDate}`
      );
      continue; // Skip invalid dates
    }

    let groupId: string;
    let groupLabel: string;

    if (isToday(createdDate)) {
      groupId = 'today';
      groupLabel = t('TODAY');
    } else if (isYesterday(createdDate)) {
      groupId = 'yesterday';
      groupLabel = t('YESTERDAY');
    } else {
      const diffInDays = differenceInCalendarDays(now, createdDate);

      if (diffInDays <= 7) {
        groupId = 'week';
        groupLabel = t('PREVIOUS_WEEK');
      } else if (diffInDays <= 30) {
        groupId = 'month';
        groupLabel = t('PREVIOUS_MONTH');
      } else {
        const year = createdDate.getFullYear();
        if (year === currentYear) {
          const monthNumber = createdDate.getMonth();
          const monthName = t(months[monthNumber]);
          groupId = `${year}-${String(monthNumber + 1).padStart(2, '0')}`; // Example: "2025-4" for April 2025
          groupLabel = toPascalCase(monthName);
        } else {
          groupId = year.toString();
          groupLabel = toPascalCase(year.toString());
        }
      }
    }

    // Create the group if it doesn't exist
    if (!indexGroupIdMap.has(groupId)) {
      indexGroupIdMap.set(groupId, result.length);
      result.push({
        id: groupId,
        label: groupLabel,
        items: [],
      });
    }

    result[indexGroupIdMap.get(groupId)!].items.push(conversation);
  }

  return result;
}

// export const useConversationsList = ({ limit = 20, skip = 0 }: fetchConversationsListParams) => {
//   return useGlobalQuery({
//     queryKey: ['getConversationsList', limit, skip],
//     queryFn: () => fetchConversationsList({ limit, skip }),
//   });
// };

// export const fetchConversationsList = async ({
//   limit = 20,
//   skip = 0,
// }: fetchConversationsListParams): Promise<SidebarGroup[]> => {
//   const res = await clients.get<{ results: SidebarItem[] }>(
//     `${process.env.REACT_APP_TASK_FORCE_API_BASE_URL}/api/conversation/conversations-list?limit=${limit}&skip=${skip}`
//   );

//   console.log('Conversations List:', res.results);

//   const groupConversationsList = groupConversations(res.results);
//   return groupConversationsList;
// };
